var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "h2",
          {
            staticClass:
              "heading__h2 font__family--gotham font__weight--medium font__color--gray mb-0",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("summary", "summary")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "heading__desc font__family--gotham font__weight--light font__color--gray-light pb-4 mb-0",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("make_order", "payment_methods")) +
                "\n            "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-4" }, [
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "h4",
            {
              staticClass:
                "heading__h4 font__family--gotham font__weight--medium font__color--gray mb-0",
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("shipping_address", "summary")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "ml-3",
              attrs: { href: "/" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.editCheckoutData(1)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "23",
                    height: "23",
                    viewBox: "0 0 23 23",
                  },
                },
                [
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#303233",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-miterlimit": "20",
                          "stroke-width": "2",
                          d: "M9 4v0H1v18h18v0-8 0",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#303233",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-miterlimit": "20",
                          "stroke-width": "2",
                          d: "M15 4l4 4",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#303233",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-miterlimit": "20",
                          "stroke-width": "2",
                          d: "M11 16v0H7v0-4 0L18 1v0l4 4v0L11 16v0z",
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.user_data.name) +
                " " +
                _vm._s(_vm.user_data.secondName)
            ),
          ]
        ),
        _vm._v(" "),
        _vm.user_data.company_name
          ? _c(
              "p",
              {
                staticClass:
                  "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
              },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.user_data.company_name)
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.user_data.nip
          ? _c(
              "p",
              {
                staticClass:
                  "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
              },
              [_vm._v("\n                " + _vm._s(_vm.user_data.nip))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.billing_data.address) + " "
            ),
            _vm.shipping_data.address_more
              ? _c("span", [_vm._v(_vm._s(_vm.billing_data.address_more))])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.billing_data.postal_code) +
                " " +
                _vm._s(_vm.billing_data.city)
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0 mt-3",
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.billing_data.country.label)
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "h4",
            {
              staticClass:
                "heading__h4 font__family--gotham font__weight--medium font__color--gray mb-0",
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("billing_address", "summary")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "ml-3",
              attrs: { href: "/" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.editCheckoutData(1)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "23",
                    height: "23",
                    viewBox: "0 0 23 23",
                  },
                },
                [
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#303233",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-miterlimit": "20",
                          "stroke-width": "2",
                          d: "M9 4v0H1v18h18v0-8 0",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#303233",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-miterlimit": "20",
                          "stroke-width": "2",
                          d: "M15 4l4 4",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        attrs: {
                          fill: "none",
                          stroke: "#303233",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-miterlimit": "20",
                          "stroke-width": "2",
                          d: "M11 16v0H7v0-4 0L18 1v0l4 4v0L11 16v0z",
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", {}, [
          _vm.shipping_data
            ? _c("div", {}, [
                _c(
                  "p",
                  {
                    staticClass:
                      "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.user_data.name) +
                        " " +
                        _vm._s(_vm.user_data.secondName)
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.shipping_data.address) +
                        " "
                    ),
                    _vm.shipping_data.address_more
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.shipping_data.address_more)),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.shipping_data.postal_code) +
                        " " +
                        _vm._s(_vm.shipping_data.city)
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0 mt-3",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.shipping_data.country.label)
                    ),
                  ]
                ),
              ])
            : !_vm.shipping_data
            ? _c(
                "p",
                {
                  staticClass:
                    "heading__desc font__family--gotham font__weight--light font__color--gray-light mb-0",
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("the_same_address", "summary")) +
                      "\n                "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.payment_method.title
        ? _c(
            "div",
            { staticClass: "col-12 border__top border__color--gray py-4" },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "heading__h4 font__family--gotham font__weight--medium font__color--gray mb-0",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("selected_payment_method", "summary")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "ml-3",
                    attrs: { href: "/" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.editCheckoutData(3)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "23",
                          height: "23",
                          viewBox: "0 0 23 23",
                        },
                      },
                      [
                        _c("g", [
                          _c("g", [
                            _c("path", {
                              attrs: {
                                fill: "none",
                                stroke: "#303233",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-miterlimit": "20",
                                "stroke-width": "2",
                                d: "M9 4v0H1v18h18v0-8 0",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("g", [
                            _c("path", {
                              attrs: {
                                fill: "none",
                                stroke: "#303233",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-miterlimit": "20",
                                "stroke-width": "2",
                                d: "M15 4l4 4",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("g", [
                            _c("path", {
                              attrs: {
                                fill: "none",
                                stroke: "#303233",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-miterlimit": "20",
                                "stroke-width": "2",
                                d: "M11 16v0H7v0-4 0L18 1v0l4 4v0L11 16v0z",
                              },
                            }),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "heading__desc font__family--gotham font__weight--light font__color--gray-light pb-2 mb-0",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.payment_method.title) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "heading__desc font__family--gotham font__weight--light font__color--gray-light pb-2 mb-0",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.payment_method.desc) +
                      "\n            "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 border__top border__color--gray py-4" },
        [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "h4",
              {
                staticClass:
                  "heading__h4 font__family--gotham font__weight--medium font__color--gray mb-0",
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("selected_shipping_method", "summary")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "ml-3",
                attrs: { href: "/" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.editCheckoutData(2)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "23",
                      height: "23",
                      viewBox: "0 0 23 23",
                    },
                  },
                  [
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#303233",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "20",
                            "stroke-width": "2",
                            d: "M9 4v0H1v18h18v0-8 0",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#303233",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "20",
                            "stroke-width": "2",
                            d: "M15 4l4 4",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("path", {
                          attrs: {
                            fill: "none",
                            stroke: "#303233",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "20",
                            "stroke-width": "2",
                            d: "M11 16v0H7v0-4 0L18 1v0l4 4v0L11 16v0z",
                          },
                        }),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "heading__desc font__family--gotham font__weight--light font__color--gray-light pb-2 mb-0",
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.shipping_method.name) +
                  "\n            "
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }